import React, { useState, useEffect } from 'react';
import axios from 'axios'; // Ensure you have axios installed: npm install axios
import {
  Box,
  Button,
  ButtonGroup,           // ← added
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorModeValue,
  useToast,
  // keyframes,
} from '@chakra-ui/react';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { RiEyeCloseLine } from 'react-icons/ri';
import DefaultAuth from 'layouts/auth/types/Default';
import illustration from 'assets/img/logo_Ucleany.jpeg';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const SignIn = () => {
  const [loginType, setLoginType] = useState('uclean'); // ← added
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const textColor = useColorModeValue('navy.700', 'white');
  const textColorSecondary = 'gray.400';
  const brandStars = useColorModeValue('blue.500', 'blue.400');
  const toast = useToast();
  const history = useHistory();


  // Function to clear expired local storage items
  const clearExpiredStorage = () => {
    const accessTokenExpiry = sessionStorage.getItem('accessTokenExpiry');
    const now = new Date().getTime();

    if (accessTokenExpiry && now > parseInt(accessTokenExpiry, 10)) {
      sessionStorage.removeItem('accessToken');
      sessionStorage.removeItem('accessTokenExpiry');
      sessionStorage.removeItem('email');
      window.location.href = '/defualt';
    }
  };

  // Check and clear expired storage on component load
  useEffect(() => {
    clearExpiredStorage();
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // const fadeIn = keyframes`
  //   from { opacity: 0; transform: translateY(-10px); }
  //   to { opacity: 1; transform: translateY(0); }
  // `;

  const handleLogin = async (e) => {
    e.preventDefault();

    // ← modified: choose URL based on toggle
    const loginUrl =
      loginType === 'ai'
        ? `${process.env.REACT_APP_API_URL3}/login`
        : `${process.env.REACT_APP_API_URL}/user/login`;

    try {
      const response = loginType === "ai" ? await axios.post(loginUrl, { grant_type:"password" ,  username: email, password }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}) : await axios.post(loginUrl, { email, password });
      
      if(loginType === "ai"){
        if (response.status === 200 ) {
          const data = response.data;
          const expiryTime = 28800000; // 8 hours in milliseconds
          const expiryDate = new Date().getTime() + expiryTime;
          sessionStorage.setItem('accessToken', data.access_token);
          sessionStorage.setItem('accessTokenExpiry', expiryDate.toString());
          sessionStorage.setItem('role_id', 1);
          const loginTimestamp = new Date().toISOString();
          sessionStorage.setItem('loginTimestamp', loginTimestamp);

          window.location.href = 'admin/AssignmentInterface';

        } else if (response.errors) {
          toast({
            title: 'An error occurred.',
            description: response.errors || 'Please try again later.',
            status: 'error',
            duration: 5000,
            isClosable: true,
            position: 'top-right',
          });
        } 
      }
      if (loginType !== "ai" && response.status === 200 ) {
        const data = response.data;
        const expiryTime = 28800000; // 8 hours in milliseconds
        const expiryDate = new Date().getTime() + expiryTime;
        sessionStorage.setItem('accessToken', data.authorization.token);
        sessionStorage.setItem('role_id', data.user.role_id);
        sessionStorage.setItem('accessTokenExpiry', expiryDate.toString());
        sessionStorage.setItem('email', data.user.first_name);
        sessionStorage.setItem('CompanyId', data.user.company_id);
        const loginTimestamp = new Date().toISOString();
        sessionStorage.setItem('loginTimestamp', loginTimestamp);
        const role = data.user.role_id;
        const ResRole = await axios.get(
          `${process.env.REACT_APP_API_URL}/company/role?page_id=1&role_id=${role}`
        );

        sessionStorage.setItem('permissions', JSON.stringify(ResRole.data.data));
        // <Redirect from='/' to={'admin/default'} />
if (loginType === 'ai') {
  history.push('/admin/Ai Dashboard');
} else {
  history.push('/admin/Main%20Dashboard/');
}

      } else if (response.errors) {
        toast({
          title: 'An error occurred.',
          description: response.errors || 'Please try again later.',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
      }
    } catch (error) {
      console.error('Error during login:', error);
      if (error.response && error.response.data && error.response.data.errors) {
        const errors = error.response.data.errors;
        const messages = Object.values(errors).flat();
        toast({
          title: 'Login error',
          description: messages.join(' '),
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
      } else {
        // Fallback error handling
        setError('User name or password is incorrect.');
        toast({
          title: 'Login error',
          description: 'User name or password is incorrect.',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
      }
    }
  };

  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration}>
       <Box display={{ base: "block", md: "none" }} w="100%" textAlign="center" mt={8} mb={2}>
        <img
          src={illustration}
          alt="Ucleany Logo"
          style={{ width: 120, height: 120, objectFit: "contain", borderRadius: 16, margin: "0 auto" }}
        />
      </Box>
        <Box position="relative" textAlign="center">
        <Box
          position="absolute"
          top="30%"
          marginTop={'250'}
          left="75%"
          transform="translateX(-20%)"
          zIndex="2"
        ></Box>
      </Box>
      <Flex
        maxW={{ base: '100%', md: 'max-content' }}
        w="100%"
        mx={{ base: 'auto', lg: '0px' }}
        me="auto"
        h="100%"
        alignItems="start"
        justifyContent="center"
        mb={{ base: '30px', md: '60px' }}
        px={{ base: '25px', md: '0px' }}
        mt={{ base: '40px', md: '14vh' }}
        flexDirection="column"
      >
        <Box me="auto" textAlign="center">
          <Heading color="blue.500" fontSize="36px" ml="20px" mb="10px">
            {loginType === 'ai' ? 'AI Dashboard Login' : 'Ucleany Admin Panel'}
          </Heading>
          <Text
            mb="36px"
            ms="4px"
            color={textColorSecondary}
            fontWeight="400"
            fontSize="md"
            ml="35px"
          >
            Enter your Email and password to sign in!
          </Text>
        </Box>
        {/* ← ADDED TOGGLE */}
        <ButtonGroup mb="24px" alignSelf="center">
          <Button
            onClick={() => setLoginType('uclean')}
            variant={loginType === 'uclean' ? 'solid' : 'outline'}
            colorScheme="blue"
          >
            Ucleany
          </Button>
          <Button
            onClick={() => setLoginType('ai')}
            variant={loginType === 'ai' ? 'solid' : 'outline'}
            colorScheme="blue"
          >
            AI Dashboard
          </Button>
        </ButtonGroup>

        <Flex
          zIndex="2"
          direction="column"
          w={{ base: '100%', md: '420px' }}
          maxW="100%"
          background="transparent"
          borderRadius="15px"
          mx={{ base: 'auto', lg: 'unset' }}
          me="auto"
          mb={{ base: '20px', md: 'auto' }}
          borderColor="blue.500"
          p="24px"
        >
          <form onSubmit={handleLogin}>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                <Text color={brandStars}>Email</Text>
              </FormLabel>
              <Input
                isRequired={true}
                variant="outline"
                borderColor="blue.500"
                focusBorderColor="blue.500"
                fontSize="sm"
                ms={{ base: '0px', md: '0px' }}
                type="text"
                placeholder="email"
                mb="24px"
                fontWeight="500"
                size="lg"
                name="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <FormLabel
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                isRequired={true}
                display="flex"
              >
                <Text color={brandStars}>Password</Text>
              </FormLabel>
              <InputGroup size="md">
                <Input
                  isRequired={true}
                  fontSize="sm"
                  placeholder="password"
                  mb="24px"
                  size="lg"
                  type={showPassword ? 'text' : 'password'}
                  variant="outline"
                  borderColor="blue.500"
                  focusBorderColor="blue.500"
                  name="password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
                <InputRightElement display="flex" alignItems="center" mt="4px">
                  <Icon
                    color={textColorSecondary}
                    _hover={{ cursor: 'pointer' }}
                    as={showPassword ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                    onClick={togglePasswordVisibility}
                  />
                </InputRightElement>
              </InputGroup>
              <Button
                fontSize="sm"
                variant="outline"
                borderColor="blue.500"
                color="blue.500"
                fontWeight="500"
                w="100%"
                h="50"
                mb="24px"
                type="submit"
                _hover={{ bg: 'blue.500', color: 'white' }}
                // animation={`${fadeIn} 0.5s ease-in-out`}
              >
                Sign In
              </Button>
            </FormControl>
            {error && (
              <Text color="blue.500" mb="8px">
                {error}
              </Text>
            )}
          </form>
        </Flex>
      </Flex>
    </DefaultAuth>
  );
};

export default SignIn;
